export default function getResource(label, vars = []) {
    const resources = {
        autoReplenish: 'Auto-Replenish',
        nextShipment: 'Next Shipment by',
        pausedDelivery: 'Paused Delivery Every',
        manageSubscription: 'Manage Subscription',
        resumeSubscription: 'Resume Subscription',
        unsubscribe: 'Unsubscribe',
        save: 'save',
        annuallyWithSubscription: 'annually with this subscription.',
        deliverEvery: 'Delivery Every',
        paused: 'Paused',
        canceled: 'Canceled',
        viewMore: 'View More',
        viewMoreSubscriptions: 'View More Subscriptions',
        item: `ITEM ${vars[0]}`,
        needHelp: 'Need Help?',
        viewFAQ: 'View FAQs',
        rateOf: `at a rate of ${vars[0]}% off`,
        stillSave: 'you can still save',
        before: 'before',
        autoReplenishPromoInfoModalTitle: 'Auto-Replenish Hot Deal',
        autoReplenishPromoInfoModalMsg1: 'Your Auto-Replenish Hot Deal discount is valid for your first 3 orders, delivered within 12 months after the initial order placement.',
        autoReplenishPromoInfoModalMsg2: 'After 3 deliveries or expiry, whichever comes first, your subscription renews at a 5% discount rate.*',
        autoReplenishPromoInfoModalButton: 'Got It',
        lastDeliveryLeft: `delivery left at ${vars[0]}% off`,
        deliveriesLeft: `deliveries left at ${vars[0]}% off`,
        discountValidUntil: `Discount valid until ${vars[0]}`,
        discountsValidUntil: `Discounts valid until ${vars[0]}`,
        or: 'Or',
        savePercentage: `save ${vars[0]}%`,
        getItBefore: 'if you get it before',
        getItNow: 'Get It Now'
    };

    return resources[label];
}
